import { AxiosError } from 'axios';

import { axiosInstanceForPublicAPIWithAuth } from '../assets/utils/axiosInstance';
import {
  InterviewQuestion,
  InterviewQuestionResponse,
} from '../slices/interviewPlannerSlice';

interface IInterviewPlannerService {
  fetchInterviewQuestions: (
    reportReferenceId: string,
  ) => Promise<InterviewQuestion[]>;
  createInterviewQuestions: (
    reportReferenceID: string,
    question: string[],
  ) => Promise<InterviewQuestion[]>;
  updateInterviewOrder: (
    reportReferenceID: string,
    questions: InterviewQuestion[],
  ) => Promise<InterviewQuestion[]>;
  deleteInterviewQuestions: (
    reportReferenceID: string,
    questionID: number,
  ) => Promise<void>;
}

const interviewPlannerService: IInterviewPlannerService = {
  fetchInterviewQuestions: async (reportReferenceId: string) => {
    try {
      const response = await axiosInstanceForPublicAPIWithAuth().get<
      InterviewQuestionResponse[]
      >(`/report/${reportReferenceId}/interview-questions`);
      const processedData = response.data.map((question) => {
        return {
          id: question.id,
          question: question.question,
          sort: question.order,
        };
      });
      return processedData;
    } catch (error) {
      const axiosError = error as AxiosError;
      throw axiosError;
    }
  },
  createInterviewQuestions: async (
    reportReferenceID: string,
    questions: string[],
  ) => {
    try {
      const body = questions.map((question) => ({
        question: question,
      }));
      const response = await axiosInstanceForPublicAPIWithAuth().post<
      InterviewQuestionResponse[]
      >(`/report/${reportReferenceID}/interview-questions`, body);
      const processedData = response.data.map((question) => {
        return {
          id: question.id,
          question: question.question,
          sort: question.order,
        };
      });
      return processedData;
    } catch (error) {
      const axiosError = error as AxiosError;
      throw axiosError;
    }
  },
  updateInterviewOrder: async (
    reportReferenceID: string,
    questions: InterviewQuestion[],
  ) => {
    try {
      const body = questions.map((question) => {
        return {
          id: question.id,
          order: question.sort,
        };
      });
      const response = await axiosInstanceForPublicAPIWithAuth().patch<
      InterviewQuestionResponse[]
      >(`/report/${reportReferenceID}/interview-questions/update-order`, body);

      const processedData = response.data.map((question) => {
        return {
          id: question.id,
          question: question.question,
          sort: question.order,
        };
      });
      return processedData;
    } catch (error) {
      const axiosError = error as AxiosError;
      throw axiosError;
    }
  },
  deleteInterviewQuestions: async (
    reportReferenceID: string,
    questionID: number,
  ) => {
    try {
      await axiosInstanceForPublicAPIWithAuth().delete(
        `/report/${reportReferenceID}/interview-questions/${questionID}`,
      );
    } catch (error) {
      const axiosError = error as AxiosError;
      throw axiosError;
    }
  },
};

export default interviewPlannerService;
